import { render, staticRenderFns } from "./app.view.vue?vue&type=template&id=39683b80&"
import script from "./app.view.ts?vue&type=script&lang=js&"
export * from "./app.view.ts?vue&type=script&lang=js&"
import style0 from "./app.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports